// extracted by mini-css-extract-plugin
export default {"paper":"RegistrationForm_paper__+VqbU","avatar":"RegistrationForm_avatar__D1BEs","username":"RegistrationForm_username__KbweY","margin5y":"RegistrationForm_margin5y__proX8"};